<template>
	<ReportProblem done="/dashboard" />
</template>

<script>
	import ReportProblem from "../shared/ReportProblem.vue"
	export default {
		components: {
			ReportProblem
		}
	}
</script>